import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKnownComponent } from './simple-icons-known.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKnownComponent ],
    exports:      [ SimpleIconsKnownComponent ],
    bootstrap:    []
})
export class SimpleIconsKnownModule {}
